<div fxLayout="row" fxLayoutAlign="center center">
    <mat-progress-spinner style="padding-right: 12px;" diameter="18" [mode]="mode" [value]="value" class="custom-spinner-color">
    </mat-progress-spinner>
    <div style="margin: 12px;">
        <span style="font-size: 16px;font-weight: 400;">{{message}}</span>
    </div>
</div>